import { Component, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { BoardsService } from 'src/app/service/boards.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { TaskStatusComponent } from '../board/task-status/task-status/task-status.component';
import { TaskStatus2Component } from '../board/task-status/task-status2/task-status2.component';
import { TaskStatus3Component } from '../board/task-status/task-status3/task-status3.component';
import { MatDialog } from '@angular/material/dialog';
import { StatusComponent } from '../board/dialog/status/status.component';
import { LateConfComponent } from '../board/dialog/late-conf/late-conf.component';
import { TaskService } from 'src/app/service/task.service';
import { GridOptions } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
export interface DialogDataTask {
  board_task_id,
  region,
  task,
  due,
  userid
}
@Component({
  selector: 'app-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrls: ['./my-tasks.component.scss'],
  standalone: false,  // NOSONAR
})
export class MyTasksComponent implements OnInit {
  gridApi: any;
  gridColumnApi: any
  defaultColDef = {
    resizable: true,
    floatingFilter: true
  };
  setPagination = true;
  paginationPageSize = 30;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  rowData;
  columnDefs;
  public getRowStyle: any;
  context;
  errorMessage: string;
  successMessage: string;
  enableCoveredTasks;
  userID;
  usertemp: string;
  userInfo: any;
  temprowData;
  temprowData2;
  temprow;
  @ViewChild('agGrid', { static: true }) agGrid: AgGridAngular
  gridOptions: GridOptions = {
    components: {
      taskStatusCellRenderer: TaskStatusComponent,
      taskStatus2CellRenderer: TaskStatus2Component,
      taskStatus3CellRenderer: TaskStatus3Component,
    }
  };
  activate_covered: any;
  // public modules: Module[] = [];
  taskID;
  activateCollapseButton: boolean;
  cellRender: any;
  detailCellRendererParams;
  dynamicHeight: number;
  totalRecords = 0; // Replace with your actual total records count
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 30;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: false },
    { value: 30, selected: true },
    { value: 50, selected: false },
  ]
  dueDateValueFormatter(params) {
    let displayValue;
    if (params.data.DUE == 'null') { // NOSONAR
      displayValue = '';
    }
    else {
      const temp = params.data.DUE.split(" ");
      const dispArr = temp[0].split("-");
      displayValue = dispArr[1] + "." + dispArr[2];
    }
    return displayValue;
  }
  periodNameValueFormatter(params) {
    let displayValue;
    if (params.data.PERIOD_NAME == 'null') { // NOSONAR
      displayValue = '';
    }
    return displayValue;
  }
  ddayValueFormatter(params) {
    let displayValue;
    if (params.data.DDAY == 'null') { // NOSONAR
      displayValue = '';
    }
    else {
      displayValue = params.data.DDAY;
    }
    return displayValue;
  }
  weekdayValueFormatter(params) {
    let displayValue;
    if (params.data.WEEKDAY == 'null') { // NOSONAR
      displayValue = '';
    }
    return displayValue;
  }
  contdateValueFormatter(params) {
    let displayValue;
    if (params.data.CONTINGENCY_DATE == 'null') { // NOSONAR
      displayValue = '';
    }
    return displayValue;
  }
  taskValueFormatter(params) {
    let displayValue;
    if (params.data.TASK == 'null') { // NOSONAR
      displayValue = '';
    }
    return displayValue;
  }
  duetimeValueFormatter(params) {
    let displayValue;
    if (params.data.DUE_TIME == 'null') { // NOSONAR
      displayValue = '';
    }
    return displayValue;
  }
  sectionValueFormatter(params) {
    let displayValue;
    if (params.data.SECTION == 'null') { // NOSONAR
      displayValue = '';
    }
    return displayValue;
  }
  sizeToFit() { this.gridApi.sizeColumnsToFit(); }
  goToNexpage() { this.gridApi.paginationGoToNextPage(); }
  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }
  goToLastPage() { this.gridApi.paginationGoToLastPage() }
  onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); }
  getCurrentPage(): boolean {
    this.currentPageNo = this.agGrid.api?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.agGrid.api?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.agGrid.api?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onGridReady(param: any) {
    this.gridApi = param.api;
    this.gridColumnApi = param.columnapi;
  }
  onGridSizeChanged(params: any) {
    params.api.sizeColumnsToFit();
  }
  MACOpenStatusChangeDialog(params) {
    const dialogRef = this.dialog.open(StatusComponent, {
      disableClose: true,
      width: '250px',
      height: '120px',
      data: {
        params: params, page: 'task-status-2'
      }
    });
    dialogRef.afterClosed().subscribe(_result => {
      //refresh data
      this.loadData();
      // }
    });
  }
  MACPastStatusChangeDialog(params) {
    console.info("data in my tasks page, on click of status chaneg", params);
    //region: params.colDef.field.slice(1, -1)
    let reg;
    if (params.data.SECTION == "USER") { // NOSONAR
      reg = null;
    } else {
      reg = params.data.SECTION;
    }
    // slice(-1,1) to remove the single quotes from region
    const dialogRef = this.dialog.open(LateConfComponent, {
      disableClose: true,
      width: '503px',
      data: {
        board_task_id: params.data.BOARD_TASK_ID, region: reg,
        task: params.data.TASK, due: params.data.DUE, userid: this.userID
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event != "cancel") { // NOSONAR
        //refresh data
        this.loadData();
      }
      // }
    });
  }
  MAIStatusChangeDialog(params) {
    console.info("data in my tasks page, on click of status chaneg", params);
    const dialogRef = this.dialog.open(StatusComponent, {
      disableClose: true,
      width: '250px',
      height: '120px',
      data: {
        params: params, page: 'task-status'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.info('The dialog was closed', result);
      //refresh data
      this.loadData();
      // }
    });
  }
  constructor(private readonly boardService: BoardsService, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly router: Router, public dialog: MatDialog, private readonly subtaskService: TaskService) {
    this.dynamicHeight = 0.665 * (window.innerHeight);
    this.columnDefs = this.getcoloumDefs()
    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {
            field: 'subtask', headerName: "SUBTASK", headerClass: "header_subtask", cellClass: "cell_mytask_subtask",
          },
          {
            field: 'op', headerName: "OP", headerClass: "header_op", cellClass: "cell_mytask_op",
            cellRenderer: function (params) {
              return `<a href="${params.data.op}" target="_blank" rel="noopener">
              <img src="../../../assets/images/file_blue.svg" style="width:14px;height:14px;"/></a>`
            }
          },
        ],
        defaultColDef: { flex: 1 },
        // detailRowAutoHeight: true,
      },
      getDetailRowData: function (params) {
        params.successCallback(params.data.subtaskRecords);
      },
    };
  }
  getcoloumDefs() {
    const header = [
      {
        headerName: "DUE", field: "DUE", headerClass: "header_due_mt", cellClass: "cell_due", minWidth: 40, width: 40,
        suppressMovable: true, resizable: false, suppressFloatingFilterInput: true,
				floatingFilterComponentParams: { suppressInput: true },
        // cellRenderer: 'agGroupCellRenderer',
        cellRendererSelector: (params) => {
          const renderData = {
            component: 'agGroupCellRenderer',
          };
          if (params.data.subtaskRecords.length > 0) {
            return renderData;
          }
          else {
            return '';
          }
        },
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
        filter: 'agDateColumnFilter',
        floatingFilter: true,
        valueFormatter: this.dueDateValueFormatter,
        filterParams: {
          filterOptions: ['inRange'],
          suppressAndOrCondition: true,
          defaultOption: 'inRange',
          maxNumConditions: 1,
          inRangeInclusive: true,
          comparator: (filterLocalDateAtMidnight, cellValue) => {
            const dateAsString = moment(cellValue).format('DD/MM/YYYY');
            const dateParts = dateAsString.split("/");
            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
            if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) { // NOSONAR
              return 0
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            else {
              return 0;
            }
          }
        }
      },
      {
        headerName: "PERIOD", field: "PERIOD_NAME", headerClass: "header_period", cellClass: "cell_period",
        width: 39,
        suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        valueFormatter: this.periodNameValueFormatter,
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
      },
      {
        headerName: "D-DAY", field: "DDAY", headerClass: "header_dDay", cellClass: "cell_dDay",
        width: 37, valueFormatter: this.ddayValueFormatter,
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
      },
      {
        headerName: "DAY", field: "WEEKDAY", headerClass: "header_day", cellClass: "cell_day",
        width: 20, valueFormatter: this.weekdayValueFormatter,
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
      },
      {
        headerName: "CONT", field: "CONTINGENCY_DATE", headerClass: "header_cont", cellClass: "cell_cont",
        width: 30, valueFormatter: this.contdateValueFormatter,
        suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,     
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
      },
      {
        headerName: "TASK", field: "TASK", headerClass: "header_task", cellClass: "cell_task", width: 235,
        autoHeight: true, valueFormatter: this.taskValueFormatter,
        suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
      },
      {
        headerName: "OP", field: "OPERATING_PROCEDURE_URL", headerClass: "header_op", cellClass: "cell_op", width: 3,
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        }, cellRendererSelector: (params) => {
          const taskStatus = {
            component: 'taskStatusCellRenderer',
            // params: {
            // 	values: ['fileAvailable'],
            // },
          };
          if (params.data.OPERATING_PROCEDURE_URL) { return taskStatus; }
          else { return null; }
        },
      },
      {
        headerName: "SECTION", field: "SECTION", headerClass: "header_section", cellClass: "cell_section",
        width: 30,
        valueFormatter: this.sectionValueFormatter,
        suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
      },
      {
        headerName: "STATUS", field: "DATA", headerClass: "header_status", cellClass: "cell_status",
        width: 30,
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
        cellRendererSelector: (params) => {
          const value = params.value;
          let status;
          if (value == 'null') { // NOSONAR
            status = null;
          }
          else {
            const regionData = value.split("|");
            status = regionData[0];
          }
          const taskStatus3 = {
            component: 'taskStatus3CellRenderer',
          };
          const taskStatus = {
            component: 'taskStatusCellRenderer',
          };
          const taskStatus2 = {
            component: 'taskStatus2CellRenderer',
          };
          if (status == null) { // NOSONAR
            return taskStatus3;
          } else if (status == "C" || status == "F" || status == "L") { // NOSONAR
            return taskStatus;
          } else if (status == "O") { // NOSONAR
            return taskStatus2;
          } else {
            return null;
          }
        }
      },
      {
        headerName: "TIME", field: "DUE_TIME", headerClass: "header_time", cellClass: "cell_time",
        width: 35, valueFormatter: this.duetimeValueFormatter,
        cellStyle: function (params) {
          if (params.data.BACKGROUND_COLOR && params.data.FONT_COLOR) {
            return { 'background-color': params.data.BACKGROUND_COLOR, 'color': params.data.FONT_COLOR }
          } else {
            return null;
          }
        },
      },
    ];
    return header
  }
  loadData() {
    this.context = {
      componentParent: this
    };
    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      this.userID = JSON.parse(userData)?.user?.userPrincipalName;
    }
    if (this.activate_covered) {
      this.enableCoveredTasks = 1;
    }
    else if (!this.activate_covered) {
      this.enableCoveredTasks = 0;
    }
    // call the service
    this.rowData = [];
    this.temprow = [];
    this.temprowData = [];
    this.temprowData2 = [];
    this.ngxUiLoaderService.start("loader-01");
    this.boardService.getMyTasksDetails(this.enableCoveredTasks, this.userID).subscribe(result => {
      console.info("calling getdetails")
      if (result?.length > 0) {
        const amIsubtask = false;
        this.temprowData = result.map(item => this.normalizeKeysToUpper(item));
        this.temprowData.forEach(element => {
          const obj = {
            "DUE": undefined,
            "PERIOD_NAME": undefined,
            "DDAY": undefined,
            "WEEKDAY": undefined,
            "CONTINGENCY_DATE": undefined,
            "TASK": undefined,
            "OPERATING_PROCEDURE_URL": undefined,
            "SECTION": undefined,
            "DATA": undefined,
            "DUE_TIME": undefined,
            "BOARD_TASK_ID": undefined,
            "subtaskRecords": [],
            "IS_SUB_TASK": undefined,
            "page": undefined
          };
          obj.DUE = element.DUE;
          obj.PERIOD_NAME = element.PERIOD_NAME;
          obj.DDAY = element.DDAY;
          obj.WEEKDAY = element.WEEKDAY;
          obj.CONTINGENCY_DATE = element.CONTINGENCY_DATE;
          obj.TASK = element.TASK;
          obj.OPERATING_PROCEDURE_URL = element.OPERATING_PROCEDURE_URL;
          obj.SECTION = element.SECTION;
          obj.DATA = element.DATA;
          obj.DUE_TIME = element.DUE_TIME;
          obj.BOARD_TASK_ID = element.BOARD_TASK_ID;
          obj.IS_SUB_TASK = element.IS_SUB_TASK;
          obj.page = "MyTasksComponent";
          this.temprowData2.push(obj);
        });
        this.temprowData2.forEach(elementMain => {
          if (elementMain.IS_SUB_TASK == 0) { // NOSONAR
            this.temprowData2.forEach(elementSub => {
              if (elementSub.IS_SUB_TASK == 1) {  // NOSONAR
                if (elementMain.BOARD_TASK_ID == elementSub.BOARD_TASK_ID) { // NOSONAR
                  elementMain.subtaskRecords.push({ "subtask": elementSub.TASK, "op": elementSub.OPERATING_PROCEDURE_URL });
                }
              }
            });
          }
        });
        this.temprowData2.forEach(elementMain => {
          if (elementMain.IS_SUB_TASK == 0) { // NOSONAR
            this.temprowData2.forEach(elementSub => {
              if (elementSub.IS_SUB_TASK == 1) {  // NOSONAR
                if (elementMain.BOARD_TASK_ID == elementSub.BOARD_TASK_ID) {  // NOSONAR
                  elementMain.subtaskRecords.push({ "subtask": elementSub.TASK, "op": elementSub.OPERATING_PROCEDURE_URL });
                }
              }
            });
          }
        });
        this.rowData = this.temprowData2;
        this.rowCount = this.rowData.length;
      }
      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      this.ngxUiLoaderService.stop("loader-01");
    });
  }
  private normalizeKeysToUpper(obj: any): any {
    const normalized: any = {};
    Object.keys(obj).forEach(key => {
      normalized[key.toUpperCase()] = obj[key];
    });
    return normalized;
  }
  ngOnInit(): void {
    this.loadData();
  }
  refresh() {
    this.loadData();
  }
  onCoveredToggle() {
    this.loadData();
  }
  onAllTaskToggle() {
    this.router.navigateByUrl('/board');
  }
  updateCalendar() {
    this.ngxUiLoaderService.start("loader-01");
    this.boardService.updateCal().subscribe(result => {
      console.info("result", result);
      if (result == "Update Calendar Successfully") { // NOSONAR
        this.ngxUiLoaderService.stop("loader-01");
        this.successMessage = 'Updated Calendar Successfully!';
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      else {
        this.ngxUiLoaderService.stop("loader-01");
        this.errorMessage = 'Updated Calendar Failed! Please Try again later.';
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
    });
  }
}